/**
 * LUTDB 相关常量配置
 */

/** IndexedDB 数据库名称 */
export const DB_NAME = 'SeamlessTextureGeneratorDB';

/** LUT 存储对象的名称 */
export const STORE_NAME = 'luts';

/** LUT 路径模板，用于构建 LUT 项的存储路径 */
export const LUT_PATH_TEMPLATE = `${STORE_NAME}/`;

/**
 * 构建 LUT 项的完整路径
 * @param id LUT 项的 ID
 * @returns 完整的存储路径
 */
export function buildLutPath(id: string): string {
    return `${LUT_PATH_TEMPLATE}${id}`;
}

/** 数据库版本号 */
export const DB_VERSION = 1;
